import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
//import styles
import style from "./a.module.scss";
//import assets
import develUpLogo from '../../assets/develup-logo.svg'

const Navbar = () => {
  const [isTilt, setIsTilt] = useState(false);
  const navigate = useNavigate();

  const { user } = useContext(UserContext)

  const controlNavbar = () => {
    if (window.scrollY === 0) {
      setIsTilt(false)
    }
    else {
      setIsTilt(true)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    }
  }, [])

  return (
    <div className={isTilt ? style.shrink : style.main}>
      <div className={style.logo} onClick={() => navigate('/')}>
        <img src={develUpLogo}></img>
      </div>

      <div className={style.menu} id="menu">
        <div className={style.menuOptions}>
          <div className={style.options} onClick={() => navigate('/mentor')}>
            Mentor
          </div>
          <div className={style.options} onClick={() => navigate('/projects')}>
            Project
          </div>
          <div className={style.options} onClick={() => navigate('/studygroups')}>
            Study Groups
          </div>
        </div>
      </div>
      <div className={style.loginOption} >
        <div className={style.options} onClick={() => navigate('/signin')}>
          {user ? user.name : 'Login/SignUp'}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
